import React from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';


import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import CssBaseline from '@material-ui/core/CssBaseline';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

const drawerWidth = 240;
const useStyles = makeStyles((theme) => ({

  root: {
    display: 'flex',
  },

  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(6) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(7) + 1,
    },
  },
  toolbarOpened: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  toolbarClosed: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },


  }));

export interface IMenuItem {
    text: string;
    icon: React.ReactNode;
    onClick?: () => void;
}

interface IMenuState {
    onClose?: () => void;
    onOpen?: () => void;
}

interface IMenuItems {
    items: IMenuItem[];
}

export type AllProps = IMenuState & IMenuItems;
export const LeftMenu = (props: AllProps) => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const isSmallDevice = () => window.innerWidth < 3 * drawerWidth;

    // Open state for the drawer
    const [open, setOpen] = React.useState(!isSmallDevice());

    // Effect to handle window resize and close the drawer if the window is resized to a small device
    React.useEffect(() => {
      const handleResize = () => {
        if (open && isSmallDevice()) {
          console.warn('Window resized to small device, closing drawer');
          handleDrawerClose();
        };
      };

      // Add event listener for resize
      window.addEventListener('resize', handleResize);

      // Cleanup event listener on unmount
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, [props]);


    // Function to handle the drawer open event
    const handleDrawerOpen = () => {
        setOpen(true);
        props.onOpen && props.onOpen();
    };

    // Function to handle the drawer close event
    const handleDrawerClose = () => {
        setOpen(false);
        props.onClose && props.onClose();
    };

    return (
      <div className={classes.root}>
        <CssBaseline />
        <Drawer
          variant="permanent"
          className={clsx(classes.drawer, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          })}
          classes={{
            paper: clsx({
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            }),
          }}
        >
          
          { open && <div className={classes.toolbarOpened}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div> }

          { !open && <div className={classes.toolbarClosed}>
            <IconButton onClick={handleDrawerOpen}>
              <MenuIcon />
            </IconButton>
          </div> }

          <Divider />

          <List>
            {props.items.map((item, index) => (
              <ListItem button key={index} onClick={item.onClick}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItem>
            ))}
          </List>
        </Drawer>
      </div>
    );
}

export default Drawer;